export const keydownEvent = 'keydown';
export const pasteEvent = 'paste';
